import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Contextone } from "./Context";
import logo from "../images/language.png";

const Language = ({}) => {
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const LanguageRef = useRef(null);
  const history = useHistory();
  const countercontext = useContext(Contextone);
  const url = countercontext.isDomain;
  const apiUrl = `https://${url}`;

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleClickOutside = (event) => {
    if (LanguageRef.current && !LanguageRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };
  const Navigate = useHistory();

  function gotoNewLanguagepage() {
    history.push("/languages");
  }

  return (
    <div
      // className="dropdown"
      ref={LanguageRef}
    >
      <img
        src={logo}
        className="Movieslogo"
        onClick={gotoNewLanguagepage}
      />
      <ul
        className="menu-bar"
      >
          <li
            className="Otherlist"
            style={{ cursor: "pointer" }}
            onClick={gotoNewLanguagepage}
          >
            Languages
          </li>
      </ul>
    </div>
  );
};

export default Language;

